var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InputTextSearch',_vm._b({model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}},'InputTextSearch',{ placeholder: _vm.placeholder, resultsCount: _vm.resultsCount },false))
}
var staticRenderFns = []

export { render, staticRenderFns }